import * as React from 'react'

import useHoverHook from 'modules/core/hooks/useHover'

const hoverContext = React.createContext<boolean>(false)

const HoverProvider = hoverContext.Provider

interface Props {
  children: React.ReactElement<any>
}

export const InjectHoverProvider = ({ children }: Props) => {
  const [hoverable, hovered] = useHoverHook(children)

  return <HoverProvider value={hovered}>{hoverable}</HoverProvider>
}

export const useHover = () => React.useContext(hoverContext)
